// This icon file is generated automatically.
var OrgStaffOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M62.7 91.36c-2.33 2.34-2.39 6.06-.12 8.33s5.99 2.2 8.32-.12a5.89 5.89 0 00.12-8.32 5.89 5.89 0 00-8.32.11zm93.47-68.86H42.5l-16.67 16V177h104.84l8.75-8.17V57.08l-9.67-9.25H42.83l9-9.33h94.67l8.67 9.33V159.5h17.33V39.17L156.17 22.5zM57.49 86.17c8.22-8.22 21.36-8.4 29.34-.42 6.38 6.38 7.55 16.05 3.56 23.87l.25-.23 24.32 24.32-.25 9.64-5.75-.35-4.52-4.51-.04-2.03-6.6.1.09-6.57-6.21.1-1.65-1.64-.41-6.77-6.19.48-2.9-2.9c-7.74 3.74-17.18 2.51-23.45-3.76-7.99-7.99-7.8-21.12.41-29.33z" } }] }, "name": "org-staff", "theme": "outlined" };
export default OrgStaffOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/OrgStaffOutlined.js
// module id = 3193
// module chunks = 0